import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

class NavbarBottomService {
  static menuUrl = `${queryParams.apiVersion}settings/navigation_links`;
  static favoriteUrl = `${queryParams.apiVersion}settings/favorite_links`;

  static async getMenu(params) {
    try {
      const res = await axios.get(this.menuUrl, { params });

      if (Array.isArray(res.data) && res.data.length) return res.data;
      return false;
    } catch {
      return false;
    }
  }

  static async toggleFavorite(params) {
    try {
      await axios.put(`${this.favoriteUrl}`, { ...params });
      return true;
    } catch (err) {
      return false;
    }
  }
}

export default NavbarBottomService;
